import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { UseOutletContextAdmin } from './Admin';
import { StateLanguage } from '../../../languages/config/StateLanguage';
import { ApiDigitalAuthRole } from '../../../services/auth/role.service';
import { GlobalSwal } from '../../../styles/swal.style';
import { errorWebHandler } from '../../../scripts/error.web.handler.script';

export interface RoleCreatePageProps {};

const RoleCreatePage: React.FunctionComponent<RoleCreatePageProps> = props => {
  const {setRoute, appServiceForUser} = UseOutletContextAdmin()
  const {lang} = StateLanguage()
  const navigate = useNavigate()

  const [mounted, setMounted] = useState(false)
  const [name, setName] = useState('')
  const [description, setDescription] = useState('')
  const [loading, setLoading] = useState(false)

  const handleSubmit = async () => {
    if (!appServiceForUser || !name.trim()) return
    setLoading(true)

    await ApiDigitalAuthRole.createRole(appServiceForUser.api_key, {
      name: name.trim(),
      description: description.trim()
    }).then((response) => {
      if (response.status === 200 || response.status === 201) {
        const roleId = response.data?.id ?? response.data?._id
        if (roleId) {
          navigate(`/main/admin/roles/${roleId}`)
        } else {
          navigate('/main/admin/roles')
        }
      } else {
        GlobalSwal.fire({
          title: response.data?.message ?? lang.labels.error,
          text: lang.labels.sorryLooksLikeThereAreSomeErrorstryAgain,
          icon: 'error',
          confirmButtonText: lang.labels.okGotIt
        })
      }
    }).catch((error) => {
      errorWebHandler(lang, error)
    }).finally(() => {
      setLoading(false)
    })
  }

  useEffect(() => {
    setMounted(true)
    setRoute({path: {root: lang.labels.administration, branch: lang.labels.createRole}, company: true})

    return () => setMounted(false)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (!mounted) return null

  return (
    <div className="w-100 h-100">
      <div className="card card-flush">
        <div className="card-header">
          <div className="card-title">
            <h3 className="fw-bolder">{lang.labels.createRole}</h3>
          </div>
        </div>
        <div className="card-body pt-0">
          <div className="mb-5">
            <label className="form-label fw-bolder">{lang.labels.name} *</label>
            <input
              type="text"
              className="form-control"
              placeholder={lang.labels.name}
              value={name}
              onChange={(e) => setName(e.target.value)}
              maxLength={100}
            />
          </div>
          <div className="mb-5">
            <label className="form-label fw-bolder">{lang.labels.description}</label>
            <textarea
              className="form-control"
              placeholder={lang.labels.description}
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              rows={3}
              maxLength={500}
            />
          </div>
          <div className="d-flex justify-content-end">
            <button className="btn btn-light me-3" type="button" onClick={() => navigate('/main/admin/roles')}>{lang.labels.cancel}</button>
            <button className="btn btn-primary" type="button" onClick={handleSubmit} disabled={loading || !name.trim()}>
              {loading ? lang.labels.loading : lang.labels.save}
            </button>
          </div>
        </div>
      </div>
    </div>
  )
};

export default RoleCreatePage;
